import { render } from "./CustomButton.vue?vue&type=template&id=ff0e91ca&scoped=true"
import script from "./CustomButton.vue?vue&type=script&lang=js"
export * from "./CustomButton.vue?vue&type=script&lang=js"

import "./CustomButton.vue?vue&type=style&index=0&id=ff0e91ca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard.lims.ninja/dashboard.lims.ninja/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff0e91ca"]])

export default __exports__